import { render, staticRenderFns } from "./SimulatorTeach.vue?vue&type=template&id=c1b89fbe&scoped=true&"
import script from "./SimulatorTeach.vue?vue&type=script&lang=js&"
export * from "./SimulatorTeach.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorTeach.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b89fbe",
  null
  
)

export default component.exports